var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedeemAmount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 1.024
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n            .st0 {\n                fill: #000000;\n            }\n        "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.557,316.597c20.281,0,83.625,0,83.625,0c16.797,0,30.406-13.609,30.406-30.406 s-13.609-30.406-30.406-30.406c-15.203,0-45.609,0-121.625,0c-76.031,0-100.094,31.672-126.703,58.281l-48.281,42.172 c-3.125,2.719-4.938,6.672-4.938,10.813v140.157c0,1.875,1.094,3.578,2.797,4.359c1.703,0.766,3.703,0.5,5.125-0.719l93.313-80 c3.297-2.797,7.672-3.984,11.922-3.219l145.406,26.438c10.141,1.844,20.594-0.484,29.016-6.438 c0,0,185.609-129.047,199.297-140.454l0,0c13.063-11.984,12.906-29.375,0.922-42.438c-12-13.094-34.375-10.313-49.297,0.734 c-13.672,11.406-107.078,72.797-107.078,72.797h-113.5l-0.359,0.156c-5.984-0.188-10.656-5.203-10.469-11.172 c0.219-5.984,5.219-10.672,11.188-10.469L225.557,316.597z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.697,0.003c-27.656,0-51.813,14.781-65.172,36.844c42.719,15.672,73.344,56.641,73.344,104.719 c0,3.547-0.203,7.047-0.531,10.516c38.516-3.844,68.594-36.328,68.594-75.859C438.932,34.128,404.807,0.003,362.697,0.003z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.979,121.222h-12.016v24.203h12.016c7.609,0,13.797-5.438,13.797-12.109 C275.775,126.66,269.588,121.222,261.979,121.222z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.244,54.441c-48.109,0-87.125,39.016-87.125,87.125c0,48.125,39.016,87.125,87.125,87.125 s87.125-39,87.125-87.125C346.369,93.457,307.354,54.441,259.244,54.441z M261.979,158.863h-12.016v17.609 c0,3.391-2.75,6.125-6.125,6.125h-3.078c-3.391,0-6.125-2.734-6.125-6.125V113.91c0-3.375,2.734-6.125,6.125-6.125h21.219 c16.078,0,29.141,11.453,29.141,25.531C291.119,147.41,278.057,158.863,261.979,158.863z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemAmount);
export default __webpack_public_path__ + "static/media/redeemAmount.1f4f712612eb7fc0a0adc86d50c322db.svg";
export { ForwardRef as ReactComponent };